import { render, staticRenderFns } from "./DashboardResetPasswordStep2.vue?vue&type=template&id=20893398&"
import script from "./DashboardResetPasswordStep2.vue?vue&type=script&lang=js&"
export * from "./DashboardResetPasswordStep2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports